import { render, staticRenderFns } from "./EMelderComponentEinstellungenMeldungsvorlagenRightElementAufgabenPersonen.vue?vue&type=template&id=5408e3d2&scoped=true"
import script from "./EMelderComponentEinstellungenMeldungsvorlagenRightElementAufgabenPersonen.vue?vue&type=script&lang=js"
export * from "./EMelderComponentEinstellungenMeldungsvorlagenRightElementAufgabenPersonen.vue?vue&type=script&lang=js"
import style0 from "./EMelderComponentEinstellungenMeldungsvorlagenRightElementAufgabenPersonen.vue?vue&type=style&index=0&id=5408e3d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5408e3d2",
  null
  
)

export default component.exports